import React from 'react'
import { Link } from 'react-router-dom'
import FormSF from '../../../../widgets/form/FormSF'
import CardUI from '../../../../widgets/layout/CardUI'
import BadgeUI from '../../../../widgets/output/BadgeUI'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'
import LabelAndValueUI from '../../../../widgets/layout/LabelAndValueUI'
import PrepaymentWaiverModalSF from './PrepaymentWaiverModalSF'
import PrepaymentRequestModalSF from './PrepaymentRequestModalSF'
import SelectUI from '../../../../widgets/input/SelectUI'
import './Prepayment.css'

const PrepaymentUI = ({ context, account, loan, prepayment, repaymentGoodStanding,
  onRefreshClick, onLoanClosureNoteRequested, loanClosureNoteSubmitted,
  onPrepaymentRequestInternal, onPrepaymentRequestExternal, onClosureLetter, prepaymentInternalSubmitted, prepaymentExternalSubmitted, closureSubmitted,
  onPrepaymentInitiate, prepaymentInitiateSubmitted, prepaymentSuccessMsg, prepaymentErrorList,
  onEmiPaymentClick, emiPaymentSubmitted, emiPaymentErrorList, selectedScheduledDate,
  onWaivedUpdateClick, waivedUpdated, onWaivedCancelClick,
  onPrepaymentRequestClick, prepaymentRequestMode, onPrepaymentRequestCancel,
  year, month, yearList, monthList, onYearChange, onMonthChange
}) =>
  <div className='su_rplst'>

    {
      prepayment && (loan.status === 'disbursed' || loan.subStatus === 'repaid' || loan.subStatus === 'prepaid') &&
      <PrepaymentInnerUI context={context} loan={loan} prepayment={prepayment} repaymentGoodStanding={repaymentGoodStanding}
        prepaymentInternalSubmitted={prepaymentInternalSubmitted}
        onPrepaymentRequestInternal={onPrepaymentRequestInternal}
        loanClosureNoteSubmitted={loanClosureNoteSubmitted}
        onLoanClosureNoteRequested={onLoanClosureNoteRequested}
        prepaymentExternalSubmitted={prepaymentExternalSubmitted}
        onPrepaymentRequestExternal={onPrepaymentRequestExternal}
        prepaymentSuccessMsg={prepaymentSuccessMsg}
        prepaymentErrorList={prepaymentErrorList}
        prepaymentInitiateSubmitted={prepaymentInitiateSubmitted}
        onPrepaymentInitiate={onPrepaymentInitiate}
        closureSubmitted={closureSubmitted}
        onClosureLetter={onClosureLetter}
        waivedUpdated={waivedUpdated}
        onWaivedUpdateClick={onWaivedUpdateClick}
        onWaivedCancelClick={onWaivedCancelClick}
        onRefreshClick={onRefreshClick}
        onPrepaymentRequestClick={onPrepaymentRequestClick}
        year={year} yearList={yearList} onYearChange={onYearChange}
        month={month} monthList={monthList} onMonthChange={onMonthChange}
      />
    }
    <PrepaymentRequestModalSF
      context={context}
      loan={loan}
      prepaymentRequestMode={prepaymentRequestMode}
      onPrepaymentRequestCancel={onPrepaymentRequestCancel}
    />
  </div>

const PrepaymentInnerUI = ({ context, loan, prepayment, repaymentGoodStanding,
  prepaymentInternalSubmitted, onPrepaymentRequestInternal, prepaymentExternalSubmitted, onPrepaymentRequestExternal, prepaymentSuccessMsg, prepaymentErrorList,
  prepaymentInitiateSubmitted, onPrepaymentInitiate, loanClosureNoteSubmitted, onLoanClosureNoteRequested,
  onPrepaymentRequestClick,
  closureSubmitted, onClosureLetter, onWaivedUpdateClick, waivedUpdated, onWaivedCancelClick, onRefreshClick,
  year, month, yearList, monthList, onYearChange, onMonthChange
}) =>
  <div className=''>
    <CardUI title='Amount to Collect for Prepayment'>
      <div className='g_flex_v g_flex_top g_m_top_50'>
        <span className='g_flex_v'>
          {
            prepayment && loan.prepaymentStatus !== 'prepaid' &&
            <table>
              <thead>
                <tr>
                  <th>Opening balance</th>
                  <th className='g_p_left_100'>Total Interest</th>
                  <th className='g_p_left_100'>GST (for leases)</th>
                  <th className='g_p_left_100'>Prepayment Fee</th>
                  <th className='g_p_left_100'>DSRA Dip Interest</th>
                  <th className='g_p_left_100'>Penal Charge</th>
                  <th className='g_p_left_100'>Out of Pocket Expenses</th>
                  <th className='g_p_left_100'>Levied</th>
                  <th className='g_p_left_100'>Waived</th>
                  <th className='g_p_left_100'>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td />
                  <td>
                    {
                      prepayment.interestF1List.map((int, i) =>
                        <RowUI key={i} value={int} />
                      )
                    }
                  </td>
                  <td />
                  <td />
                  <td>
                    {
                      prepayment.dsraDipInterestF1List.map((int, i) =>
                        <RowUI key={i} value={int} />
                      )
                    }
                  </td>
                  <td>
                    {
                      prepayment.defaultInterestF1List.map((int, i) =>
                        <RowUI key={i} value={int} />
                      )
                    }
                  </td>
                  <td />
                  <td />
                  <td />
                  <td />
                </tr>
                <tr>
                  <td className='g_text_right'>{prepayment.remainingBalanceF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.totalInterestF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.emiTaxF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.prepaymentFeeF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.totalDsraDipInterestF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.totalDefaultInterestF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.outOfPocketExpensesF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.leviedAmountF1}</td>
                  <td className='g_text_right g_p_left_100'>{prepayment.waivedAmountF1 ? '(' + prepayment.waivedAmountF1 + ')' : ''}
                    <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted"
                      onClick={onWaivedUpdateClick} >
                    </span>
                  </td>
                  <td className='g_text_right g_p_left_100 g_h3'>{prepayment.prepaymentAmountF1}</td>
                </tr>
              </tbody>
            </table>
          }
          <PrepaymentWaiverModalSF context={context} loan={loan}
            updateMode={waivedUpdated} onCancelClick={onWaivedCancelClick}
            onRefreshClick={onRefreshClick} prepayment={prepayment}
          />
          {
            loan.prepaymentStatus === 'prepaid' &&
            <span className='g_flex_v breakups'>
              <span className='g_flex_h'>Amount<span>{loan.prepaymentAmountF1}</span></span>
              <span className='g_muted'>
                <span className='g_flex_h'>O/S Balance<span>{prepayment.remainingBalanceF1}</span></span>
                <span className='g_flex_h'>Interest<span>{prepayment.interestF1}</span></span>
                <span className='g_flex_h'>GST (for leases)<span>{prepayment.emiTaxF1}</span></span>
                <span className='g_flex_h'>Prepayment fee<span>{prepayment.prepaymentFeeF1}</span></span>
                <span className='g_flex_h'>Late Int<span>{prepayment.lateInterestF1}</span></span>
                <span className='g_flex_h'>DSRA Int<span>{prepayment.dsraDipInterestF1}</span></span>
                <span className='g_flex_h'>Default Int<span>{prepayment.defaultInterestF1}</span></span>
                <span className='g_flex_h'>Levied<span>{prepayment.leviedAmountF1}</span></span>
                <span className='g_flex_h'>
                  Waived<span>{prepayment.waivedAmountF1 ? '(' + prepayment.waivedAmountF1 + ')' : ''}</span>
                </span>
              </span>
            </span>
          }
        </span>
        <div className='g_flex_h g_flex_top g_m_top_50'>
          <div>
            {/* <span className='g_flex_h g_flex_left'>
              <Link className='g_m_right_25' onClick={onPrepaymentRequestInternal} to='#'>
                Download Loan Closure Request Internal
              </Link>
              <SpinnerUI show={prepaymentInternalSubmitted} reserveSpace={true} />
            </span> */}
            <span className='g_flex_h g_flex_left g_m_top_25'>
              <SelectUI selectedKey={year} optionList={yearList} onChange={onYearChange} placeholder='Year' />
              <span className='g_m_left_25' />
              <SelectUI selectedKey={month} optionList={monthList} onChange={onMonthChange} placeholder='Month' />
              <Link className='g_m_left_25' onClick={onLoanClosureNoteRequested} to='#'>
                Download Loan Closure Request
              </Link>
              <SpinnerUI className='g_m_left_25' show={loanClosureNoteSubmitted} reserveSpace={true} />
            </span>
            <span className='g_flex_h g_flex_left'>
              <Link className='g_m_right_25' onClick={onPrepaymentRequestExternal} to='#'>
                Download Loan Closure Request External
              </Link>
              <SpinnerUI show={prepaymentExternalSubmitted} reserveSpace={true} />
            </span>
            <span className='g_flex_h g_flex_left g_m_top_25 '>
              <Link className='g_m_right_25' onClick={onClosureLetter} to='#'>
                Download Loan Closed Note
              </Link>
              <SpinnerUI show={closureSubmitted} reserveSpace={true} />
            </span>
            <span className='g_flex_h g_flex_left g_m_top_25'>
              <Link className='g_m_right_25' onClick={onPrepaymentRequestClick} to='#' >
                Send Loan Prepayment Request
              </Link>
            </span>
          </div>
          <span className='g_flex_v g_text_right'>
            {
              loan.prepaymentStatus &&
              <span className='g_m_bottom_25'><BadgeUI label={loan.prepaymentStatus} /></span>
            }
            {
              loan.prepaymentRequestDateF &&
              <LabelAndValueUI label='Request Date'>{loan.prepaymentRequestDateF}</LabelAndValueUI>
            }
            {
              loan.prepaymentInitiateDateF &&
              <LabelAndValueUI label='Initiate Date'>{loan.prepaymentInitiateDateF}</LabelAndValueUI>
            }
            {
              loan.closedDateF &&
              <LabelAndValueUI label='Prepayment Date'>{loan.closedDateF}</LabelAndValueUI>
            }
          </span>
        </div>
      </div>
      {
        loan.prepaymentRequestDateF && !loan.prepaymentInitiateDateF &&
        <div className='g_flex_h'>
          <span>Transfer outstanding loan amount to Clime Finance:</span>
          <FormSF context={context} buttonLabel='Initiate Prepayment'
            onSubmit={onPrepaymentInitiate} busy={prepaymentInitiateSubmitted}
            successMsg={prepaymentSuccessMsg} errorList={prepaymentErrorList}
          />
        </div>
      }
    </CardUI>

    <CardUI title='Amount to Collect to Convert Loan to Good Standing (if Delinquent)' className='g_m_top_100'>
      <table>
        <thead>
          <tr>
            <th>Scheduled Date</th>
            <th className='g_p_left_100'>EMI</th>
            <th className='g_p_left_100'>Total Interest</th>
            <th className='g_p_left_100'>DSRA Dip Interest</th>
            <th className='g_p_left_100'>Penal Charge</th>
            <th className='g_p_left_100'>Principle</th>
            <th className='g_p_left_100'>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            repaymentGoodStanding.goodStandingItems.map((amount, i) =>
              <tr key={i}>
                <td>{amount.scheduledDateF1}</td>
                <td className='g_text_right g_p_left_100'>{amount.emiTaxF5}</td>
                <td className='g_text_right g_p_left_100'>{amount.interestF5}</td>
                <td className='g_text_right g_p_left_100'>{amount.dsraDipInterestF5}</td>
                <td className='g_text_right g_p_left_100'>{amount.defaultInterestF5}</td>
                <td className='g_text_right g_p_left_100'>{amount.principalF5}</td>
                <td className='g_text_right g_p_left_100'>{amount.unpaidAmountF5}</td>
              </tr>
            )
          }
          <tr>
            <td><b>Total</b></td>
            <td />
            <td className='g_text_right'>{repaymentGoodStanding.totalInterestF5}</td>
            <td className='g_text_right g_p_left_100'>{repaymentGoodStanding.totalDsraDipInterestF5}</td>
            <td className='g_text_right g_p_left_100'>{repaymentGoodStanding.totalDefaultInterestF5}</td>
            <td />
            <td className='g_text_right g_p_left_100'>{repaymentGoodStanding.goodStandingAmountF5}</td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div >

const RowUI = ({ label, value }) =>
  <span className={`g_flex_v g_text_right g_muted`}>
    {label}
    <span>{value}</span>
  </span>

export default PrepaymentUI
